import React from "react"

function Start() {
  return (
    <div id="s-buddy-start">
      <h1>Buddy Start</h1>
    </div>
  )
}

export default Start